import React from "react";
import { Header } from "@/components/site/Header";
import { Contact } from "@/components/site/Contact";
import { Reveal } from "@/components/site/Reveal";
import { useSeo } from "@/hooks/useSeo";

// Mise en page éditoriale sobre, cohérente avec l'identité du site.
export const LegalPage = ({ title, seoTitle, path, children }) => {
  useSeo({
    title: seoTitle || `${title} — Ninaa Beauty`,
    description: `${title} — Ninaa Beauty, institut de beauté et bien-être à Toulouse.`,
    path,
  });
  return (
    <div className="App" data-testid="legal-page">
      <Header />
      <main className="page-enter bg-[#faf7f2]">
        <div className="max-w-2xl mx-auto px-6 pt-10 md:pt-16 pb-20 md:pb-28">
          <Reveal>
            <h1 className="font-serif-display font-light text-[#4b2018] text-4xl md:text-5xl mb-10">
              {title}
            </h1>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="space-y-8 text-[#4b2018] leading-relaxed">
              {children}
            </div>
          </Reveal>
        </div>
      </main>
      <Contact />
    </div>
  );
};

export const LegalBlock = ({ heading, children }) => (
  <section>
    <h2 className="font-serif-display font-light text-[#4b2018] text-xl md:text-2xl mb-3">
      {heading}
    </h2>
    <div className="space-y-2 text-sm md:text-base text-[#4f4a42] leading-relaxed">
      {children}
    </div>
  </section>
);

// Marqueur visuel discret pour les informations à compléter
export const ToFill = ({ children }) => (
  <span className="text-[#b07a63] italic">{children || "[À compléter]"}</span>
);
